<template>
  <div class="home">
    <div class="bg1"></div>
    <section id="banner-section">
      <Banner/>
    </section>
    <!-- <div class="scroller">
      <a href="#down" class="down-scroll">test</a>
    </div> -->
    <section id="down">
      <Dates/>
    </section>
    <section id="bottom">
      <BottomCTA/>
    </section>
    
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Banner from '@/components/Home/Banner.vue'
import Dates from '@/components/Home/Dates.vue'
import BottomCTA from '@/components/Home/BottomCTA.vue'

export default {
  name: 'Home',
  components: {
    Banner,
    Dates,
    BottomCTA
  }
}
</script>

<style>
  .home-ctas{
    width: 196px;
    height: 52px;
    font-size: 20px;
    font-weight: bold;

  }

  
  .bg1{
    position: absolute;
    top: 0;
    z-index: -1;
    background-image: url('~@/assets/bg1.png' ) no-repeat;
    width: 100%;
    height: 100%;
  }

  .home{
    padding: 0px 8vw;
    /* padding-bottom: 80px; */
    
  }

  .scroller{
    width: 100%;
    text-align: center;
  }

  section{
    
  }



  /* #banner-section{
    scroll-snap-align: center;
  }

  section#down {
    margin-top: 30vh;
    padding-top: 80px;
    scroll-snap-align: start; 
    max-height: 100vh;
  }

  section#bottom{
    scroll-snap-align: end; 
  } */
</style>



